import { Colors } from '../consts/Colors.js';
import { Fonts } from '../consts/Fonts.js';
import { Sizes } from '../consts/Sizes.js';
import AbstractScene from './AbstractScene.js';

export default class Preloader extends AbstractScene {
    constructor() {
        super({
            key: 'Preloader',
        });
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();

        // Ajout du texte de chargement
        this.loadingText = this.make.text({
            x: this.width / 2,
            y: this.height / 2,
            text: 'Loading... 0%',
            style: {
                fontFamily: Fonts.Text.h2,
                fontSize: Sizes.Text.h2,
                fill: '#008FED',
                strokeThickness: 8,
            },
        });

        this.loadingText.setOrigin(0.5, 0.5);

        this.loadSprites();

        this.load.on('progress', (value) => {
            this.loadingText.text = 'Loading... ' + Math.floor(value * 100) + '%';
        });

        this.load.on(
            'complete',
            function () {
                this.nextScene();
            },
            this
        );
    }

    loadSprites() {
        // animated arrows
        this.load.image('arrow1', 'assets/images/arrows/arrow1.png');
        this.load.image('arrow2', 'assets/images/arrows/arrow2.png');
        this.load.image('arrow3', 'assets/images/arrows/arrow3.png');
        this.load.image('arrow4', 'assets/images/arrows/arrow4.png');
        this.load.image('arrow5', 'assets/images/arrows/arrow5.png');

        // intro
        this.load.image('background-mobile', 'assets/images/bg-mobile.png');
        this.load.image('background', 'assets/images/bg.png');
        this.load.image('introRobot', 'assets/images/intro/robot.png');
        this.load.image('logoLoreal', 'assets/images/intro/logo-loreal.png');
        this.load.image('shadowRobot', 'assets/images/intro/shadow.png');
        this.load.image('logoForecast', 'assets/images/intro/logo.png');

        // icones
        this.load.image('fleche', 'assets/images/icones/fleche.png');
        this.load.image('suivantBtn', 'assets/images/icones/suivant-btn.png');
        this.load.image('valideBtn', 'assets/images/icones/valide-btn.png');
        this.load.image('lock', 'assets/images/icones/lock.png');
        this.load.image('playCircle', 'assets/images/icones/play-circle.png');
        this.load.image('play', 'assets/images/icones/play.png');
        this.load.image('pause', 'assets/images/icones/pause.png');
        this.load.image('download', 'assets/images/icones/download.png');
        this.load.image('close', 'assets/images/icones/close.png');

        // menu
        this.load.image('cadreModule', 'assets/images/menu/cadre-module.png');
        this.load.image('cadreModuleSelected', 'assets/images/menu/cadre-module-selected.png');
        this.load.image(
            'cadreModuleSelectedHover',
            'assets/images/menu/cadre-module-selected-hover.png'
        );
        this.load.image('cadreTexteMenu', 'assets/images/menu/cadre-texte.png');
        this.load.image('robotVideo', 'assets/images/menu/robot1.png');
        this.load.image('robotInfo', 'assets/images/menu/robot2.png');
        this.load.image('robotQuiz', 'assets/images/menu/robot3.png');

        // video
        this.load.video('videoLoreal', 'assets/videos/lorealsalesgrowth.mp4');

        // quiz
        this.load.image('robotQuestionQuiz', 'assets/images/quiz/robot-quiz.png');
        this.load.image('backSous', 'assets/images/quiz/backsous.png');

        //debrief
        this.load.image('debriefText1', 'assets/images/quiz/debrief/text1.png');
        this.load.image('debriefText2', 'assets/images/quiz/debrief/text2.png');
        this.load.image('debriefText3', 'assets/images/quiz/debrief/text3.png');
        this.load.image('debriefText4', 'assets/images/quiz/debrief/text4.png');
        this.load.image('debriefText5', 'assets/images/quiz/debrief/text5.png');
        this.load.image('debriefText6', 'assets/images/quiz/debrief/text6.png');
        this.load.image('debriefText7', 'assets/images/quiz/debrief/text7.png');
        this.load.image('debriefImage1', 'assets/images/quiz/debrief/image1.png');
        this.load.image('debriefImage2', 'assets/images/quiz/debrief/image2.png');
        this.load.image('debriefImage3', 'assets/images/quiz/debrief/image3.png');
        this.load.image('debriefImage4', 'assets/images/quiz/debrief/image4.png');
        this.load.image('debriefImage5', 'assets/images/quiz/debrief/image5.png');
        this.load.image('debriefImage6', 'assets/images/quiz/debrief/image6.png');
        this.load.image('debriefImage7', 'assets/images/quiz/debrief/image7.png');
    }
}
